export default [
  {
    path: '/otherService', // 其他服务
    name: 'otherService',
    component: () => {
      return import(
        /* webpackChunkName: "otherservice" */ '@/views/otherservice/index.vue'
      )
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/changePwd', // 设置密码
    name: 'changePwd',
    component: () => {
      return import(
        /* webpackChunkName："otherservice" */ '@/views/otherservice/ChangePwd.vue'
      )
    }
  },
  {
    path: '/advice', // 意见反馈
    name: 'advice',
    component: () => {
      return import(
        /* webpackChunkName："otherservice" */ '@/views/otherservice/Advice.vue'
      )
    }
  },
  {
    path: '/changePhone', // 更换手机
    name: 'changePhone',
    component: () => {
      return import(
        /* webpackChunkName: "otherservice"*/ '@/views/otherservice/ChangePhone.vue'
      )
    }
  },
  {
    path: '/messageConfig', // 消息设置
    name: 'messageConfig',
    component: () => {
      return import(
        /* webpackChunkName: "otherservice" */ '@/views/otherservice/MessageConfig.vue'
      )
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/langConfig', // 语言设置
    name: 'langConfig',
    component: () => {
      return import(
        /* webpackChunkName: "otherservice" */ '@/views/otherservice/LangSetting.vue'
      )
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/accountManage', // 账号管理
    name: 'accountManage',
    component: () => {
      return import(
        /* webpackChunkName: "otherservice" */ '@/views/otherservice/AccountManage.vue'
      )
    },
    meta: {
      keepAlive: true
    }
  }
]
